require('./dist/icon/ds6/icon.css');
